import { FACEBOOK, INSTAGRAM, LINKEDIN, YOUTUBE } from "@vahak/core/dist/constants/socialMediaLinks";

import { getLcvRouteSlugs } from "./data";

export const LCV_ROUTE_PLAY_STORE_URL = "https://6r7cz.app.link/googleplay";

export const LCV_BOOKING_ROUTE_SLUGS = getLcvRouteSlugs();

export const getLcvBookingRoutePath = (slug: string) => `/lcv-booking/${slug}`;

export const LCV_ROUTE_SOCIAL_LINKS = [
    {
        label: "Facebook",
        href: FACEBOOK,
        iconClassName: "ti ti-brand-facebook"
    },
    {
        label: "LinkedIn",
        href: LINKEDIN,
        iconClassName: "ti ti-brand-linkedin"
    },
    {
        label: "YouTube",
        href: YOUTUBE,
        iconClassName: "ti ti-brand-youtube"
    },
    {
        label: "Instagram",
        href: INSTAGRAM,
        iconClassName: "ti ti-brand-instagram"
    }
] as const;
